import React, { useEffect, useState, useCallback } from "react";
import { fetchRechargeHistory } from "../services/api";

const RechargeHistory = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({});

  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
    min_amount: "",
    max_amount: "",
    page: 1,
    per_page: 10,
  });

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchRechargeHistory(filters);
      setData(res.data);
      setPagination(res.pagination);
    } catch (err) {
      console.error("Failed to fetch recharge history:", err);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilterChange = (e) => {
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value, page: 1 }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchData();
  };

  const handleReset = () => {
    setFilters({
      start_date: "",
      end_date: "",
      min_amount: "",
      max_amount: "",
      page: 1,
      per_page: 10,
    });
  };

  const handlePageChange = (newPage) => {
    setFilters((prev) => ({ ...prev, page: newPage }));
  };

  return (
    <div className="page-container">
      <h2 className="page-title">Recharge History</h2>

      <form className="filter-form" onSubmit={handleSearch}>
        <input
          type="date"
          name="start_date"
          value={filters.start_date}
          onChange={handleFilterChange}
          className="filter-input"
        />
        <input
          type="date"
          name="end_date"
          value={filters.end_date}
          onChange={handleFilterChange}
          className="filter-input"
        />
        <input
          type="number"
          name="min_amount"
          value={filters.min_amount}
          onChange={handleFilterChange}
          className="filter-input"
          placeholder="Min Amount"
        />
        <input
          type="number"
          name="max_amount"
          value={filters.max_amount}
          onChange={handleFilterChange}
          className="filter-input"
          placeholder="Max Amount"
        />
        <button type="submit" className="filter-btn">Search</button>
        <button type="button" className="filter-btn reset-btn" onClick={handleReset}>Reset</button>
      </form>

      <div className="table-container">
        <table className="call-logs-table">
          <thead>
            <tr className="table-header-row">
              <th className="table-header">#</th>
              <th className="table-header">USER ID</th>
              <th className="table-header">AMOUNT</th>
              <th className="table-header">DATE & TIME</th>
              <th className="table-header">METHOD</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="4" className="loading-cell">Loading...</td></tr>
            ) : data.length === 0 ? (
              <tr><td colSpan="4" className="empty-cell">No records found</td></tr>
            ) : (
              data.map((item) => (
                <tr key={item.id} className="table-row">
                  <td className="table-cell">{item.id}</td>
                  <td className="table-cell">{item.user_id || "N/A"}</td>
                  <td className="table-cell">{item.amount?.toFixed(2) ?? "0.00"}</td>
                  <td className="table-cell">{item.created_at ?? "N/A"}</td>
                  <td className="table-cell">{item.recharge_method ?? "N/A"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {pagination.total_items > 0 && (
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {((pagination.current_page - 1) * filters.per_page) + 1}–{Math.min(pagination.current_page * filters.per_page, pagination.total_items)} of {pagination.total_items}{' '}
            accounts (Page {pagination.current_page} of {pagination.total_pages})
          </div>
          <div className="pagination-buttons">
            <button
              onClick={() => handlePageChange(pagination.current_page - 1)}
              disabled={!pagination.has_prev}
              className={`pagination-btn ${!pagination.has_prev ? 'disabled' : ''}`}
            >
              Previous
            </button>
            <button
              onClick={() => handlePageChange(pagination.current_page + 1)}
              disabled={!pagination.has_next}
              className={`pagination-btn ${!pagination.has_next ? 'disabled' : ''}`}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RechargeHistory;